import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { formatDate } from "@utils/formatNumber"
import { slugMaterialName } from "@utils/helpers"

import { CategoryPricesTable } from "@components/CategoryPricesTable"

export const CategoryPrices = ({
  locale,
  countryCurrency,
  countryName,
  meanPricesByMaterial,
  pricesLastDate,
  language,
}) => {
  const { t } = useTranslation()

  const updatedOn = t("CategoryPrices_updated").replace(
    "[%1]",
    formatDate(new Date(pricesLastDate), locale)
  )

  const generatePageTitle = () => {
    let pageTitle = `${t("CategoryPrices_title")}`
    if (countryName !== "International") pageTitle += ` - ${t(countryName)}`
    return pageTitle
  }

  return (
    <div className="bg-lblue pt-10 pb-5 md:pb-10 desk:p-15 font-inter">
      <div className="w-full md:w-[680px] desk:w-[1136px] m-auto">
        <p
          className="desk:text-left text-dblue text-20 desk:text-40 
		  		font-medium 
				mb-4 desk:mb-10 
				ml-6 md:ml-0 desk:ml-[100px]
				leading-6
			   	md:pt-[60px] pt-[40px]"
        >
          {generatePageTitle()}
        </p>
        <p className="desk:text-left text-dblue text-10 ml-6 md:ml-0 desk:ml-[100px] leading-6">
          {updatedOn}
        </p>

        <div
          className="w-full ml-0 mr-0 
					desk:ml-[50px] desk:mr-[50px] desk:mt-[20px] desk:p-8 
					md:p-4 md:ml-0 md:mr-0 
					bg-white"
        >
          <CategoryPricesTable
            currency={countryCurrency}
            locale={locale}
            meanPricesByMaterial={meanPricesByMaterial}
            countrySlug={slugMaterialName(countryName)}
            language={language}
          />
        </div>
      </div>
    </div>
  )
}
